<template>
  <Dashboard
    :results-set="resultsSet"
    :context="context"
    :query-id="queryId"
    :query-configuration="queryConfiguration"
    :on-fire-query="onFireQuery"
    v-on="$listeners"
  />
</template>

<script>
import Dashboard from '@/agilis/components/Dashboard/Dashboard.vue'
import dataMixin from '@/agilis/components/Dashboard/mixin/dataMixin'

export default {
  name: 'DashboardWrapper',

  components: {
    Dashboard
  },

  mixins: [
    dataMixin
  ],

  props: {
    context: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}

</script>
